export const PAYMENT_FAILED_PHONE_NUMBER = '0203 932 4128';
export const PAYMENT_FAILED_TEL_HREF = 'tel:02039324128';

export const CUSTOMER_CARE_PHONE_NUMBER = '0800 188 884';
export const CUSTOMER_CARE_TEL_HREF = 'tel:0800188884';
